export default __webpack_public_path__ + "static/bartoszs-9b2c5e8853ddad8d0d455bde3c8b4d26.webp";